import { useEffect, type ComponentProps } from "react";
import { STUDIO } from "../lib/studio.ts";

/** Public booking actions all use the studio's Fresha booking page. */
export function BookingLink(props: Omit<ComponentProps<"a">, "href">) {
  return <a {...props} href={STUDIO.bookingUrl} />;
}

/** Preserve old /book links without sending new clients into the former flow. */
export function BookingRedirect() {
  useEffect(() => {
    window.location.replace(STUDIO.bookingUrl);
  }, []);

  return (
    <main className="page section">
      <p>Taking you to Fresha to book your appointment…</p>
      <BookingLink className="btn">Continue to booking</BookingLink>
    </main>
  );
}
